import React from 'react';
import { ArcButton, ArcDialog, ArcPasswordInput, ArcStack } from '@src/core/ui';

import { ResetPasswordFormProps } from './types';
import { useForm } from 'react-hook-form';
import { IResetPasswordForm } from '@src/features/settings/entities';
import { EMPTY_VALUE, REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { useResetUserPasswordMutation } from '@src/features/settings/redux';
import { toast } from 'react-toastify';
import { trackError, toTrackedError } from '@src/core/sentry';

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = (props) => {
  const { user, open, onClose } = props;

  const [resetUserPassword, { isLoading: isSubmitting }] = useResetUserPasswordMutation();

  const { register, handleSubmit, reset, formState: { errors } } = useForm<IResetPasswordForm>({ 
    defaultValues: { 
      newPassword: EMPTY_VALUE, 
      newPassword2: EMPTY_VALUE, 
    }  
  });

  const closeDialog = () => {
    reset();
    onClose();
  };

  const onResetUserPassword = (data: IResetPasswordForm) => {
    resetUserPassword({ id: user.id, data }).unwrap().then(() => {
      toast.success('SET USER ROLE SUCCESS TEXT');
      closeDialog();
    }).catch((err: unknown) => {
      trackError(toTrackedError(err), { code: 'FE_0018', extra: { action: 'resetUserPassword', userId: user.id } });
      toast.error('Failed to reset password');
    });
  };

  return (
    <ArcDialog 
      open={open} 
      onClose={closeDialog} 
      title='Reset password'>
      <ArcStack 
        spacing={2} 
        component='form'
        onSubmit={handleSubmit(onResetUserPassword)}>

        <ArcPasswordInput 
          autoComplete='off'
          error={Boolean(errors.newPassword)} 
          helperText={errors.newPassword?.message}
          label='New password' 
          {...register('newPassword', { 
            required: REQUIRED_VALIDATION_TEXT
          })} />


        <ArcPasswordInput 
          autoComplete='off'
          error={Boolean(errors.newPassword2)} 
          helperText={errors.newPassword2?.message}
          label='Confirm new password' 
          {...register('newPassword2', { 
            required: REQUIRED_VALIDATION_TEXT 
          })} />

        <ArcButton.brand type='submit' isLoading={isSubmitting}> 
          Save 
        </ArcButton.brand>

      </ArcStack>
    </ArcDialog>
  );
};

export default ResetPasswordForm;
